/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon16Light = forwardRef('ShareNetworkIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 4a2.5 2.5 0 1 1 .621 1.65L6.375 7.217a2.498 2.498 0 0 1 0 1.563l2.746 1.57a2.5 2.5 0 1 1-.497.868L5.88 9.648a2.5 2.5 0 1 1 0-3.299l2.746-1.569A2.498 2.498 0 0 1 8.5 4ZM11 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-7 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" })));
});
